import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ComponentLoader from './component-loader'
import AdminLayout from 'layouts/admin/components/admin-layout'
import Team from 'layouts/admin/team/team'
import Teams from 'layouts/admin/team'

// MAIN
const Admin = ComponentLoader(lazy(() => import('../layouts/admin/admin')))

// ACCOUNT
const Account = ComponentLoader(
  lazy(() => import('../layouts/common/account/account'))
)
const Profile = ComponentLoader(
  lazy(() => import('../layouts/common/account/profile'))
)
const UpdatePassword = ComponentLoader(
  lazy(() => import('../layouts/common/account/update-pass'))
)

// CARD-HOLDER
const CardHolders = ComponentLoader(
  lazy(() => import('../layouts/admin/cardholder'))
)
const CardHoldersList = ComponentLoader(
  lazy(() => import('../layouts/admin/cardholder/cardholder'))
)
const Bulkmanage = ComponentLoader(
  lazy(() => import('../layouts/admin/cardholder/bulkmanage'))
)
const ViewInsight = ComponentLoader(
  lazy(() => import('../layouts/admin/components/view-insight'))
)
const ViewCustomer = ComponentLoader(
  lazy(() => import('../layouts/admin/cardholder/view-customer'))
)

const Videos = ComponentLoader(lazy(() => import('../layouts/admin/videos')))

// BUSINESS CARDS ($8 one-time cards ordered from the marketing site)
const BusinessCards = ComponentLoader(
  lazy(() => import('../layouts/admin/business-cards'))
)

const EnterpriseAccounts = ComponentLoader(
  lazy(() => import('../layouts/admin/enterprise'))
)

// MANAGE DESIGN
const Designs = ComponentLoader(lazy(() => import('../layouts/admin/design')))
const CreateDesign = ComponentLoader(
  lazy(() => import('../layouts/admin/design/design-form'))
)
const DesignList = ComponentLoader(
  lazy(() => import('../layouts/admin/design/design-table'))
)

// NFS PASS
const NFSPassModule = ComponentLoader(
  lazy(() => import('../layouts/admin/nfs-pass/nfs-pass-module'))
)
const NFSPassList = ComponentLoader(
  lazy(() => import('../layouts/admin/nfs-pass/nfs-pass-list'))
)
const NFSPassForm = ComponentLoader(
  lazy(() => import('../layouts/admin/nfs-pass/nfs-pass-form'))
)

// BROADCAST
const BroadCastModule = ComponentLoader(
  lazy(() => import('../layouts/admin/broadcast'))
)
const BroadCast = ComponentLoader(
  lazy(() => import('../layouts/admin/broadcast/broadcast'))
)

// SETTINGS
const OrganisationSettings = ComponentLoader(
  lazy(() => import('../layouts/admin/settings/settings'))
)

const LoyaltyDemo = ComponentLoader(
  lazy(() => import('../layouts/admin/loyalty-demo'))
)

const Payfast = ComponentLoader(
  lazy(() => import('../layouts/admin/payfast/payfast'))
)

const Rebranding = ComponentLoader(
  lazy(() => import('../layouts/admin/rebranding/rebranding'))
)

// PLAN
const PlanModule = ComponentLoader(lazy(() => import('../layouts/admin/plan')))
const PlanList = ComponentLoader(
  lazy(() => import('../layouts/admin/plan/plan-list'))
)

const PaymentSuccess = ComponentLoader(
  lazy(() =>
    import(
      '../layouts/authentication/register/organisation/subscription/payment-success'
    )
  )
)

const PaymentFailed = ComponentLoader(
  lazy(() =>
    import(
      '../layouts/authentication/register/organisation/subscription/payment-failed'
    )
  )
)

const OrganisationRoutes = [
  {
    path: '',
    element: <AdminLayout />,
    children: [
      {
        path: '',
        index: true,
        element: <Admin />,
      },
      {
        path: 'account',
        element: <Account />,
        children: [
          {
            path: '',
            index: true,
            element: <Profile />,
          },
          {
            path: 'password',
            element: <UpdatePassword />,
          },
        ],
      },
      {
        path: 'customers',
        element: <CardHolders />,
        children: [
          {
            path: '',
            index: true,
            element: <CardHoldersList />,
          },
          {
            path: 'bulkmanage',
            element: <Bulkmanage />,
          },
          {
            path: 'view-insight',
            element: <ViewInsight />,
          },
          {
            path: 'view/:id',
            element: <ViewCustomer />,
          },
        ],
      },
      {
        path: 'videos',
        element: <Videos />,
      },
      {
        path: 'business-cards',
        element: <BusinessCards />,
      },
      {
        path: 'enterprise-accounts',
        element: <EnterpriseAccounts />,
      },
      {
        path: 'team',
        element: <Teams />,
        children: [
          {
            path: '',
            index: true,
            element: <Team />,
          },
          // {
          //   path: 'bulkmanage',
          //   element: <Bulkmanage />,
          // },
        ],
      },

      {
        path: 'design',
        element: <Designs />,
        children: [
          {
            path: '',
            index: true,
            element: <DesignList />,
          },
          {
            path: 'create',
            element: <CreateDesign />,
          },
          {
            path: 'update',
            element: <CreateDesign />,
          },
        ],
      },
      {
        path: 'nfs-pass/*',
        element: <NFSPassModule />,
        children: [
          {
            index: true,
            element: <NFSPassList />,
          },
          {
            path: 'create',
            element: <NFSPassForm />,
          },
          {
            path: 'view/:passId',
            element: <NFSPassForm />,
          },
          {
            path: 'edit/:passId',
            element: <NFSPassForm />,
          },
        ],
      },
      {
        path: 'settings',
        element: <OrganisationSettings />,
      },
      {
        path: 'loyalty-demo',
        element: <LoyaltyDemo />,
      },
      {
        path: 'plans',
        element: <PlanModule />,
        children: [
          {
            path: '',
            index: true,
            element: <PlanList />,
          },
        ],
      },

      {
        path: '*',
        element: <Navigate to={''} />,
      },
    ],
  },
  {
    path: 'payfast',
    element: <Payfast />,
  },
  {
    path: 'payment-success',
    element: <PaymentSuccess />,
  },
  {
    path: 'payment-failed',
    element: <PaymentFailed />,
  },
  {
    path: '*',
    element: <Navigate to={''} />,
  },
]

export default OrganisationRoutes
